/**
 * Created by rathompson on 1/5/22
 * File: TermsAndConditions
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

/**
 *   TODO: Brief what is this component/class do
 */
import { useMemo, useState } from 'react'
// import { Checkbox, SubmitButton } from '@panwds/react-form'
import { SubmitButton, Checkbox } from '@panwds/react-form-legacy'
import {
  AGREE_TERMS_PREFIX,
  LINK_TERMS,
  ACTIVATE_TOOLTIP_NO_MSG
} from './FormFooterConstant'
import { Body, Tooltip } from '@panwds/react-ui'
import { useFormContext } from 'react-hook-form'
import styled from 'styled-components'
import { isNonemptyArray } from '../utils'

export interface IFormFooterProps {
  buttonText: string,
  dataTestId: string,
  loading?: boolean
}

const LinkWrapper = styled.div`
  display: flex;
  column-gap: 5px;
  align-items: center;
  a {
    font-size : 12px !important;
  }
`
const debugShowErrors = false

const FormFooter = (props: IFormFooterProps) => {
  const { loading = false, buttonText = 'Activate Now', dataTestId } = props
  const { formState } = useFormContext()
  const { errors = {}, isDirty, isSubmitting } = formState
  const hasFormErrors = Boolean(Object.keys(errors)?.length)
  const errorValues = Object.values(errors)
  // const { is_eula_accepted } = errors
  const [checked, setChecked] = useState(false)
  // useEffect(() => {
  //   if (checked) {
  //     // Commenting it out. This is causing re-validation of the form and any manually set errors are being cleared.
  //     //trigger()
  //   }
  // }, [checked, errors, trigger])

  const isActivateBtnDisabled = useMemo(() => {
    return !(isDirty && checked) || hasFormErrors || isSubmitting
  }, [checked, hasFormErrors, isDirty, isSubmitting])

  const toolTipMessage = useMemo<String>(() => {
    if (!isActivateBtnDisabled) {
      return ACTIVATE_TOOLTIP_NO_MSG
    }
    if (hasFormErrors) {
      return errorValues && isNonemptyArray(errorValues) ? String(errorValues[0]?.message) : 'You have one or more issues with your form'
    }
    else if (!checked) {
      return 'You must agree to the terms and conditions'
    }
    return isSubmitting ? 'Activation in Process' : ''
  }, [checked, errorValues, hasFormErrors, isActivateBtnDisabled, isSubmitting])

  return (
    <div className="tw-flex tw-flex-1 tw-justify-between tw-p-4">
      <LinkWrapper>
        {/*<div className="tw-flex tw-gap-1 tw-items-center" >*/}
        <Checkbox
          disabled={loading}
          name={'is_eula_accepted'}
          label={''}
          register={{
            required: false,
            onChange: async (event) => setChecked(event.currentTarget.checked),
          }} />
        <Body size='xs' addClassName='dark:tw-text-white'>{AGREE_TERMS_PREFIX}
          <a className='tw-text-link tw-text-base tw-cursor-pointer tw-text-default tw-truncate' target='_blank' href='https://www.paloaltonetworks.com/content/dam/pan/en_US/assets/pdf/legal/palo-alto-networks-end-user-license-agreement-eula.pdf' rel='noreferrer'>
            {LINK_TERMS}
          </a>
        </Body>
      </LinkWrapper>
      {/*</div>*/}
      <div className="tw-flex tw-gap-2">
        <Tooltip label={toolTipMessage}>
          <div>
            <SubmitButton
              data-testid={dataTestId}
              disabled={isActivateBtnDisabled}
            >{buttonText}</SubmitButton>
          </div>
        </Tooltip>
      </div>
      {/* for debugging purpose */}
      {debugShowErrors && <div className='cm-fixed cm-h-36 cm-w-96 cm-bg-white cm-left-0 cm-bottom-0 cm-z-50'>
        {JSON.stringify(errorValues)}
      </div>}
    </div>
  )
}
export default FormFooter
